import { render, staticRenderFns } from "./home-box2.vue?vue&type=template&id=33913bda&scoped=true&"
import script from "./home-box2.vue?vue&type=script&lang=js&"
export * from "./home-box2.vue?vue&type=script&lang=js&"
import style0 from "./home-box2.vue?vue&type=style&index=0&id=33913bda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33913bda",
  null
  
)

export default component.exports